/*
 * Copyright 2025 coze-dev Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

export { GlobalLayout } from './components/global-layout';
export { useAppInit } from './hooks/use-app-init';
export { useHasSider } from './components/global-layout-composed/hooks/use-has-sider';
export { AccountDropdown } from './components/account-dropdown';
export { useAccountSettings } from './components/account-dropdown/account-settings';
export {
  applySSOPreferencesFromURL,
  getSSOLocaleOverride,
} from './sso-preferences';
export type { SSOPreferences } from './sso-preferences';
